import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from '@material-ui/core';
import Authorize from 'components/Authorize';
import { permissionProfiles } from 'components/Authorize/permissionProfiles';
import LoadingSpinner from 'components/LoadingSpinner';
import { useEffect, useState } from 'react';
import { useStyles } from "./AddActivityPriceStyles";
import NotificationProvider from 'components/NotificationProvider';
import { useGetLotsQuery } from 'features/lots/lotSlice';
import { useGetVehicleTypesQuery } from 'features/vehicles/vehicleSlice';
import { useGetVendorsQuery } from 'features/vendor/vendorSlice';
import { useAddActivityPriceMutation, useGetAllActivityPricingQuery } from 'features/pricing/pricingSlice';
import ActivityPriceDialogContent from '../ActivityPriceDialogContent';
import { toggleOptions } from '../pricingConsts';
import { useGetClientsQuery } from 'features/clients/clientSlice';
import { mapAppliesToToServerLotOptions } from '../../../pricingManagement/utils/lotOptionsMapper';

function AddActivityPrice({ open, handleClose, setOpenModel }) {
    const classes = useStyles();

    let { data: activityPricing, error: activityPricingError, isFetching: isLoadingActivityPricing } = useGetAllActivityPricingQuery();
    let { data: lots, error: lotError, isLoading: isLoadingLots } = useGetLotsQuery();
    let { data: vehicleTypes, error: vehicleTypesError, isLoading: isLoadingVehicleTypes } = useGetVehicleTypesQuery();
    let { data: vendors, error: vendorsError, isLoading: isLoadingVendors } = useGetVendorsQuery();
    let { data: clients, error: clientError, isLoading: isLoadingClients } = useGetClientsQuery(null);

    const [addActivityPrice, { isLoading: isAdding }] = useAddActivityPriceMutation();

    const [activityPriceToAdd, setActivityPriceToAdd] = useState();

    useEffect(() => {
        setActivityPriceToAdd({
            lotId: [],
            vendorId: [],
            priceAppliesTo: toggleOptions.SPECIFIC_LOTS,
            includeNonTenant: false
        });
    }, [open])

    lots = lots || [];
    vehicleTypes = vehicleTypes || [];
    vendors = vendors || [];
    activityPricing = activityPricing || [];
    clients = clients || [];

    const onChange = (key, val) => {
        setActivityPriceToAdd({ ...activityPriceToAdd, [key]: val });
    };

    const onChangeVehicleTypes = (val) => {
        if (val[val.length - 1] == null && val.length !== 0) {
            val = [null];
            onChange("vehicleTypeIdsList", val);
        }
        else {
            if (activityPriceToAdd?.vehicleTypeIdsList?.includes(null)) {
                val = val.filter(v => v != null);
                onChange("vehicleTypeIdsList", val);
            } else {
                onChange("vehicleTypeIdsList", val);
            }
        }
    };

    const onClose = () => {
        setActivityPriceToAdd({})
        handleClose()
    }

    const onClickFinish = async () => {
        let existing = activityPricing.find(a =>
            a?.activityItemId === activityPriceToAdd?.activityItemId &&
            a?.vendorId === activityPriceToAdd?.vendorId &&
            a?.lotId === activityPriceToAdd?.lotId &&
            a?.vehicleTypeIdsList === activityPriceToAdd?.vehicleTypeIdsList &&
            a?.useInventory === activityPriceToAdd?.useInventory &&
            a?.allLots === activityPriceToAdd?.allLots &&
            a?.allPTenantLots === activityPriceToAdd?.allTenantLots)
        if (existing) {
            setOpenModel(true)
        }
        else {
            const lotOptions = mapAppliesToToServerLotOptions(activityPriceToAdd?.priceAppliesTo);
            activityPriceToAdd.vehicleTypeIdsList = activityPriceToAdd?.vehicleTypeIdsList?.includes(null) ? null : activityPriceToAdd?.vehicleTypeIdsList
            activityPriceToAdd.lotId = activityPriceToAdd?.priceAppliesTo == toggleOptions.SPECIFIC_LOTS ? activityPriceToAdd?.lotId : null;
            activityPriceToAdd.allLots = lotOptions.allLots;
            activityPriceToAdd.allTenantLots = lotOptions.allTenantLots;
            activityPriceToAdd.isInternal = true;
            let result = await addActivityPrice(activityPriceToAdd);
            if (result && !result.error) {
                NotificationProvider.success("Activity added successfully");
                onClose();
            } else {
                NotificationProvider.error("Something happened, try again or contact support");
            }
        }
    }

    const isValid = activityPriceToAdd?.activityItemId && !!activityPriceToAdd?.vendorId?.length && ((!activityPriceToAdd?.notSupported && activityPriceToAdd?.price) || activityPriceToAdd?.notSupported)
        && (activityPriceToAdd?.priceAppliesTo === toggleOptions.SPECIFIC_LOTS ? !!activityPriceToAdd?.lotId?.length : true);
    const isSaving = isAdding;
    const isLoading = isLoadingLots || isLoadingVehicleTypes || isLoadingVendors || isLoadingActivityPricing;

    return (
        <>
            <Authorize profile={permissionProfiles.PRICING.MANAGE_PPRICING}>
                <Dialog open={open} onClose={onClose} >
                    <DialogTitle >
                        <div className={classes.dialogTitle}> Add Activity Price </div>
                    </DialogTitle>
                    <DialogContent>
                        <ActivityPriceDialogContent
                            isLoading={isLoading}
                            activityPrice={activityPriceToAdd}
                            onChange={onChange}
                            vendors={vendors}
                            lots={lots}
                            vehicleTypes={vehicleTypes}
                            onChangeVehicleTypes={onChangeVehicleTypes}
                            multiple={true}
                            clients={clients} />
                    </DialogContent>
                    <DialogActions>
                        <div className={classes.btnContainer}>
                            <Button className={classes.button} variant="outlined"
                                onClick={onClose}>Cancel</Button>
                            <Button
                                onClick={onClickFinish}
                                disabled={!isValid || isSaving}
                                className={classes.button}
                                variant="contained" >
                                {isSaving ? "Saving..." : "Finish"}
                            </Button>
                        </div>
                    </DialogActions>
                </Dialog>
                <LoadingSpinner loading={isLoading || isSaving} />
            </Authorize>
        </>
    );
}

export default AddActivityPrice;

